import React, { useState } from 'react'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

import { Button, Icon, IconButton } from '~components/internal'
import { type ContactEntryId, type EmailIdentity, type IdentityId, type TargetId } from '~types'

import './AddContactDialog.scss'
import AddContactFormControl, { type ContactFormData } from './AddContactFormControl'

interface AddContactDialogProps {
  open: boolean
  onClose: () => void
  onComplete?: () => void
  onSaveSuccess?: (
    contactEntryId: ContactEntryId,
    identityId: IdentityId,
    targetId: TargetId,
  ) => void
  update?: boolean
  onUpdate?: (formData: ContactFormData) => Promise<void>
  contactInfo?: ContactFormData
  inputOrganization?: EmailIdentity | null
  onDelete?: () => void
}

const AddContactDialog: React.FC<AddContactDialogProps> = ({
  open,
  onClose,
  onComplete,
  onSaveSuccess,
  update,
  onUpdate,
  contactInfo,
  inputOrganization,
  onDelete,
}) => {
  const [isFormInvalid, setIsFormInvalid] = useState<boolean>(false)
  const [isSaved, setIsSaved] = useState<boolean>(false)

  return (
    <Dialog className='add-contact-dialog' open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle className='add-contact-dialog__title'>
        {update ? 'Update Contact' : 'Add Contact'}
        <IconButton size='small' onClick={onClose}>
          <Icon fontSize='small' name='close' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <AddContactFormControl
          initialData={contactInfo}
          onClose={onClose}
          onComplete={onComplete}
          update={update}
          onUpdate={onUpdate}
          isSaved={isSaved}
          setIsSaved={setIsSaved}
          onFormValidChange={setIsFormInvalid}
          onSaveSuccess={onSaveSuccess}
          inputOrganization={inputOrganization}
        />
      </DialogContent>
      <DialogActions className='add-contact-dialog__actions'>
        {update && onDelete && (
          <Button color='error' onClick={onDelete}>
            Delete Contact
          </Button>
        )}
        <Box className='add-contact-dialog__standard-actions'>
          <Button variant='outlined' onClick={onClose}>
            Cancel
          </Button>
          <Button variant='contained' onClick={() => setIsSaved(true)} disabled={isFormInvalid}>
            {update ? 'Save' : 'Add'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default AddContactDialog
